import { useEffect, useState } from "react";

// Per-row expiry countdown for Pending Approvals (UX §5.2.5 + §8.6.2).
// 60-second window, ticks down each second, switches to amber at ≤10s,
// renders "Expired" when elapsed. The component drives presentation only;
// the authoritative expiry is enforced backend-side at approval time.

type Props = { initialSeconds: number };

export const CountdownChip = ({ initialSeconds }: Props) => {
  const [s, setS] = useState(initialSeconds);

  useEffect(() => {
    if (s <= 0) {
      return;
    }
    const id = window.setTimeout(() => setS(s - 1), 1000);
    return () => window.clearTimeout(id);
  }, [s]);

  if (s <= 0) {
    return (
      <span
        className="num"
        style={{ color: "var(--tp-bad)", fontSize: 11 }}
        aria-live="polite"
      >
        Expired
      </span>
    );
  }

  const mm = String(Math.floor(s / 60));
  const ss = String(s % 60).padStart(2, "0");
  const color = s <= 10 ? "var(--tp-warn)" : "var(--tp-fg-3)";

  return (
    <span
      className="num"
      style={{ color, fontSize: 11 }}
      aria-label={`Expires in ${s} seconds`}
    >
      {mm}:{ss}
    </span>
  );
};
